<vwui-header>
  <h2 a11yPageTitleLevel="1">{{ "PAGE_RISK_LIBRARY.title" | translate}}</h2>
</vwui-header>

@if (loadingSpinnerService.isSpinnerVisible()) {
  <vwui-spinner></vwui-spinner>
}

@if (!loadingSpinnerService.isSpinnerVisible()) {
  <app-library-mgmt [library]="riskLibrary" [companyTypeId]="companyTypeId">
  </app-library-mgmt>
}
